import React, { useEffect, useRef, useState } from 'react';
import { Container, Typography, Box, CircularProgress } from '@mui/material';
import Banner from "../components/Banner";
import RecursoDestacado from '../components/RecursoDestacado';
import CarouselArticulos from './../components/CarouselArticulos';
import ArticulosConPaginacion from '../components/ArticulosConPaginacion';
// HUB FORMATIVO - Formulario de suscripción (secciones ocultas, descarga libre)
// import SeccionSuscripcion from '../components/SubscriptionSection';
// import SectionHowtoAccess from '../components/SectionHowtoAccess';
import { fetchAllBlogPosts } from './../components/wordpressUtils';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const recursosDisponibles = [
  {
    titulo: 'Estrategia de resiliencia patrimonial: Preservación y transición transgeneracional de capital',
    tipo: 'E-BOOK',
    descripcion: 'Guía estratégica diseñada para ayudar a empresarios y familias de alto patrimonio a proteger su capital y asegurar la continuidad de su legado financiero.',
    imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1790355224/ebm/ESTRATEGIA_DE_RESILIENCIA_PATRIMONIAL.png',
    categoria: 'EMPRESA FAMILIAR',
    fecha: '2026-07-27',
    archivo: 'https://drive.google.com/file/d/10nDpDtIXvrOYn5gL-vuGGQFkydxigfE0/view'
  },
  {
    titulo: 'Protocolo familiar: Cómo alinear a la familia para asegurar el futuro del negocio',
    tipo: 'E-BOOK',
    descripcion: 'Guía clara para comprender los alcances de un protocolo familiar. En él descubrirás cómo este marco regula la sucesión, previene conflictos de interés, protege el patrimonio y consolida la continuidad del negocio entre generaciones.',
    imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1785773539/ebm/Portada-im%C3%A1gen-familiar-protocolo.png',
    categoria: 'EMPRESA FAMILIAR',
    fecha: '2026-07-27',
    archivo: 'https://drive.google.com/file/d/1nUeb2CKQJbxotmjCWU0xr1IJrQCD5Kbu/view'
  },
  {
    titulo: 'Gobernanza VS. Gobierno Corporativo',
    tipo: 'INFOGRAFÍA',
    descripcion: 'Entérate de la diferencia entre gobernanza y gobierno corporativo, y descubre cómo ambos conceptos fortalecen la toma de decisiones, la transparencia, la confianza y la sostenibilidad de las organizaciones.',
    imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1755789266/ebm/EBM___gvg_madmz1.png',
    categoria: 'GOBIERNO',
    fecha: '2025-08-21',
    archivo: 'https://drive.google.com/file/d/1NvoWYKXK78D_gXjLBxmFbo0xKHOkwVIR/view'
  },
  {
    titulo: 'Radiografía de la empresa familiar',
    tipo: 'INFOGRAFÍA',
    descripcion: 'Conoce la realidad de las empresas familiares en México y Latinoamérica. Descubre los principales retos que enfrentan y aprende qué estrategias son fundamentales para asegurar la continuidad y el crecimiento del legado empresarial.',
    imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1755792076/ebm/infografia_ebm_ce99j9.png',
    categoria: 'EMPRESA FAMILIAR',
    fecha: '2025-08-20',
    archivo: 'https://drive.google.com/file/d/1c1ROYtCGYMad10ouOcYnjYCxF_U_fOin/view'
  },
  {
    titulo: 'Institucionalizar para perdurar: estrategias, estructuras y gestión',
    tipo: 'E-BOOK',
    descripcion: 'Entérate de cómo institucionalizar tu empresa mediante estrategias, estructuras y sistemas de gestión que fortalezcan la toma de decisiones, reduzcan la dependencia de personas y aseguren el desarrollo y la sostenibilidad del negocio a largo plazo.',
    imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197927/ebm/Institucionalizar_xekahb.png',
    categoria: 'EMPRESA',
    fecha: '2023-12-01',
    archivo: 'https://drive.google.com/file/d/1-qI-VwukKnFKdndj5wWk9UixPaywLYJK/view'
  }
];

export default function HubFormativo() {
  const blurRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  // HUB FORMATIVO - Descarga libre sin suscripción obligatoria marcado como TRUE
  const [estaSuscrito, setEstaSuscrito] = useState(true);
  const [wordpressArticles, setWordpressArticles] = useState([]);
  const [isLoadingArticles, setIsLoadingArticles] = useState(true);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, [location.pathname]);

  // HUB FORMATIVO - Ya no se valida suscripción en sessionStorage
  // useEffect(() => {
  //   const suscrito = sessionStorage.getItem('estaSuscrito') === 'true';
  //   setEstaSuscrito(suscrito);
  // }, []);

  useEffect(() => {
    const node = blurRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingArticles(true);
        const wpArticles = await fetchAllBlogPosts();
        setWordpressArticles(wpArticles);
      } catch (err) {
        console.error('Error al obtener artículos:', err);
      } finally {
        setIsLoadingArticles(false);
      }
    };

    fetchData();
  }, []);

  const articulos = [
    {
      titulo: 'El lenguaje común de la alta dirección: Finanzas, cumplimiento y sostenibilidad',
      tipo: 'E-BOOK',
      descripcion: 'Un análisis sobre un desafío recurrente en las organizaciones: el trabajo aislado entre áreas y la desconexión al balancear la rentabilidad, los riesgos legales y el impacto a largo plazo.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1792170998/ebm/LENGUAJE_COMUN_ALTA_DIRECCION_bi98kp.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2026-10-26',
      archivo: 'https://drive.google.com/file/d/1a7FJhQqFvmpFUV1B7v9SMge2yQP9JuLf/view'
    },
    {
      titulo: 'Estrategia de resiliencia patrimonial: Preservación y transición transgeneracional de capital',
      tipo: 'E-BOOK',
      descripcion: 'Guía estratégica diseñada para ayudar a empresarios y familias de alto patrimonio a proteger su capital y asegurar la continuidad de su legado financiero.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1790355224/ebm/ESTRATEGIA_DE_RESILIENCIA_PATRIMONIAL.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2026-07-27',
      archivo: 'https://drive.google.com/file/d/10nDpDtIXvrOYn5gL-vuGGQFkydxigfE0/view'
    },
    {
      titulo: 'Protocolo familiar: Cómo alinear a la familia para asegurar el futuro del negocio',
      tipo: 'E-BOOK',
      descripcion: 'Guía clara para comprender los alcances de un protocolo familiar. En él descubrirás cómo este marco regula la sucesión, previene conflictos de interés, protege el patrimonio y consolida la continuidad del negocio entre generaciones.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1785773539/ebm/Portada-im%C3%A1gen-familiar-protocolo.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2026-07-27',
      archivo: 'https://drive.google.com/file/d/1nUeb2CKQJbxotmjCWU0xr1IJrQCD5Kbu/view'
    },
    {
      titulo: 'La empresa: Sistemas interdependientes',
      tipo: 'E-BOOK',
      descripcion: 'Descubre cómo fortalecer la empresa mediante la institucionalización, la planeación estratégica y el gobierno corporativo. Conoce las herramientas clave para construir una organización más sólida, sostenible y preparada para crecer a largo plazo.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197819/ebm/LaEmpresaSistemas_hjmu2v.png',
      categoria: 'La Empresa',
      fecha: '2023-10-15',
      archivo: 'https://drive.google.com/file/d/1DImuEMlwzpjznKMrYs-Kk1j1zvpfp8Ca/view'
    },
    {
      titulo: 'La familia: Sistemas interdependientes',
      tipo: 'E-BOOK',
      descripcion: 'Explora cómo fortalecer la unión y la continuidad de la familia empresaria mediante el gobierno familiar, el protocolo y el Family Office. Aprende a prevenir conflictos, profesionalizar la gestión del patrimonio y preparar a las nuevas generaciones.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197844/ebm/LaFamilia_ljokng.png',
      categoria: 'La Familia',
      fecha: '2023-11-20',
      archivo: 'https://drive.google.com/file/d/1bU4PbbWlVdltdrogSWWSRZAD9yqTx6Kz/view'
    },
    {
      titulo: 'La propiedad: Sistemas interdependientes',
      tipo: 'E-BOOK',
      descripcion: 'Aprende cómo gestionar y proteger el patrimonio con una visión de largo plazo. Descubre estrategias para planificar la sucesión, profesionalizar a la familia empresaria y construir un legado que preserve y haga crecer la riqueza a través de las generaciones.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197872/ebm/LaPropiedadSistemasInterdependientes_lccibu.png',
      categoria: 'La propiedad',
      fecha: '2023-09-05',
      archivo: 'https://drive.google.com/file/d/1d0z2KbOmAqUHJNEmTLUj6fSJHXvaqeR5/view'
    },
    {
      titulo: 'Impacto y prevención en empresas y sociedades de la corrupción',
      tipo: 'E-BOOK',
      descripcion: 'Conoce el impacto de la corrupción en las organizaciones y aprende a prevenirla mediante una cultura ética, controles internos, políticas de transparencia y estrategias de cumplimiento que fortalezcan la confianza y protejan la reputación.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197902/ebm/ImpactoYPrevencion_t3vlyk.png',
      categoria: 'FAMILIA',
      fecha: '2023-08-12',
      archivo: 'https://drive.google.com/file/d/1Hr8bVYiLG2UkOuFjxjVMO3STwNJuao0S/view'
    },
    {
      titulo: 'Institucionalizar para perdurar: estrategias, estructuras y gestión',
      tipo: 'E-BOOK',
      descripcion: 'Entérate de cómo institucionalizar tu empresa mediante estrategias, estructuras y sistemas de gestión que fortalezcan la toma de decisiones, reduzcan la dependencia de personas y aseguren el desarrollo y la sostenibilidad del negocio a largo plazo.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197927/ebm/Institucionalizar_xekahb.png',
      categoria: 'EMPRESA',
      fecha: '2023-12-01',
      archivo: 'https://drive.google.com/file/d/1-qI-VwukKnFKdndj5wWk9UixPaywLYJK/view'
    },
    {
      titulo: 'Dirección General: Liderazgo empresarial',
      tipo: 'E-BOOK',
      descripcion: 'Entérate de cómo desarrollar una dirección efectiva, fortalecer la institucionalización, liderar con visión, rendir cuentas y preparar una sucesión que garantice la continuidad y sostenibilidad de la organización.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197948/ebm/DireccionGeneral_o9zj7e.png',
      categoria: 'PROPIEDAD',
      fecha: '2023-07-18',
      archivo: 'https://drive.google.com/file/d/1zbneRZUPs7gh85S_kH9pezgFJCf01wAK/view'
    },
    {
      titulo: 'Sucesores preparando el futuro',
      tipo: 'E-BOOK',
      descripcion: 'Explora cómo preparar a la siguiente generación para gestionar adecuadamente la empresa familiar. Aprende a planificar la sucesión, desarrollar habilidades clave y asegurar una transición que preserve el legado.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197971/ebm/SucesoresPreparandoElFuturo_wy38jg.png',
      categoria: 'PROPIEDAD',
      fecha: '2023-07-18',
      archivo: 'https://drive.google.com/file/d/1KZ5QBOOmZf7A-oRjl_nXEkMIvuZpbihp/view'
    },
    {
      titulo: 'El modelo de los tres círculos',
      tipo: 'E-BOOK',
      descripcion: 'Descubre cómo el modelo de los tres círculos ayuda a gestionar la relación entre familia, empresa y propiedad. Aprende a definir roles, prevenir conflictos, planificar la sucesión y fortalecer la gobernanza para el crecimiento de la empresa familiar.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750197993/ebm/ModulosDeLosTresCirculos_xfaett.png',
      categoria: 'PROPIEDAD',
      fecha: '2023-07-18',
      archivo: 'https://drive.google.com/file/d/1_YYHzoJZHjnO-jxinnVXZWTdL65o_xIA/view'
    },
    {
      titulo: 'Gobernanza VS. Gobierno Corporativo',
      tipo: 'INFOGRAFÍA',
      descripcion: 'Entérate de la diferencia entre gobernanza y gobierno corporativo, y descubre cómo ambos conceptos fortalecen la toma de decisiones, la transparencia, la confianza y la sostenibilidad de las organizaciones.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1755789266/ebm/EBM___gvg_madmz1.png',
      categoria: 'GOBIERNO',
      fecha: '2025-08-21',
      archivo: 'https://drive.google.com/file/d/1NvoWYKXK78D_gXjLBxmFbo0xKHOkwVIR/view'
    },
    {
      titulo: 'Radiografía de la empresa familiar',
      tipo: 'INFOGRAFÍA',
      descripcion: 'Conoce la realidad de las empresas familiares en México y Latinoamérica. Descubre los principales retos que enfrentan y aprende qué estrategias son fundamentales para asegurar la continuidad y el crecimiento del legado empresarial.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1755792076/ebm/infografia_ebm_ce99j9.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-08-21',
      archivo: 'https://drive.google.com/file/d/1c1ROYtCGYMad10ouOcYnjYCxF_U_fOin/view'
    },
    {
      titulo: 'Business Process Management',
      tipo: 'E-BOOK',
      descripcion: 'Descubre cómo el Business Process Management (BPM) te ayuda a diseñar, documentar, analizar y mejorar los procesos de tu empresa. Aprende a optimizar la eficiencia operativa, estandarizar actividades y fomentar una cultura de mejora continua.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757003023/ebm/1ebe68a9-590b-47da-a601-69e787d3031f.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-08-16',
      archivo: 'https://drive.google.com/file/d/10cFymfDUkr1D4OK3O67qMZZ1G_tZAVzq/view'
    },
    {
      titulo: 'Sistema de gobierno corporativo',
      tipo: 'INFOGRAFÍA',
      descripcion: 'Asegura la trascendencia de tu organización. Descubre las funciones clave de la Asamblea de Accionistas y el Consejo de Administración, los beneficios de la profesionalización y la sucesión, y la ruta práctica para implementarlos con éxito.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757089316/ebm/c89b3be4-9e30-491f-99e2-c34215b74857.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-08-16',
      archivo: 'https://drive.google.com/file/d/113BVxH_R_JhZYy1f2y5QtpplNhJ7a9r7/view'
    },
    {
      titulo: 'Modelo de negocio, el valor de tu empresa',
      tipo: 'INFOGRAFÍA',
      descripcion: 'Aprende a diseñar y fortalecer el modelo de negocio de tu empresa. Descubre cómo definir tu propuesta de valor, identificar oportunidades, optimizar la generación de ingresos y alinear la estrategia para construir un negocio más rentable, competitivo y sostenible.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757346146/ebm/24d83865-45f0-46f9-8246-ded6917fc277.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-08-16',
      archivo: 'https://drive.google.com/file/d/1uFwSXuTAuP_hUljw6noxrgbdnl1M8aXh/view'
    },
    {
      titulo: 'Empresa familiar y temas en tendencia',
      tipo: 'E-BOOK',
      descripcion: 'Conoce los desafíos que enfrentan las empresas familiares y descubre cómo la sucesión, la innovación y herramientas como el protocolo familiar y el family office son claves para fomentar la continuidad y el desarrollo.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757346438/ebm/fe501234-1fc0-41df-a28f-b0f1e12a1af8.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2023-07-16',
      archivo: 'https://drive.google.com/file/d/1b_UAasTefiRwy3I2v9qGaJCodKOwb_Zz/view'
    },
    {
      titulo: 'Origen del concepto del gobierno corporativo',
      tipo: 'E-BOOK',
      descripcion: 'Conoce el origen, la evolución y los fundamentos del gobierno corporativo, así como sus principales órganos y elementos. Descubre cómo las buenas prácticas fortalecen la transparencia, la toma de decisiones y la sostenibilidad de las organizaciones.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757347624/ebm/d891a771-8f61-4970-8de7-72dfba7d8443.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-07-16',
      archivo: 'https://drive.google.com/file/d/1Jc5k9zRSgAWxVXqoc0Ta1bnNEVJkSl1L/view'
    },
    {
      titulo: 'Consejo de administración, factor equilibrio de la empresa',
      tipo: 'E-BOOK',
      descripcion: 'Conoce cómo equilibrar y guiar tu negocio. Aprende sobre el Consejo de Administración y sus funciones clave para definir el rumbo estratégico, su estructura recomendada y los roles directivos necesarios para supervisar la operación con total transparencia.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757432329/ebm/3989afa6-3796-4504-b15a-1aa2e35a81e9.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-09',
      archivo: 'https://drive.google.com/file/d/1H1bfNV2h-jOfCZqfK8FDUCapZHU_mFxC/view'
    },
    {
      titulo: 'La figura del consejero independiente',
      tipo: 'E-BOOK',
      descripcion: 'Descubre el valor del consejero independiente y explora cómo su visión objetiva aporta equilibrio en la toma de decisiones. Además, conoce los requisitos, limitantes y el proceso de inducción efectivo para potenciar la gobernanza.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757432432/ebm/48575eba-b445-489a-9e34-08fd47756755.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-09',
      archivo: 'https://drive.google.com/file/d/10t6rULl2vuUh9vcrSWhuik1TXcKJuqjs/view'
    },
    {
      titulo: 'Institucionalización para PYMES',
      tipo: 'E-BOOK',
      descripcion: 'Descubre el papel del consejero independiente en el gobierno corporativo. Aprende cómo su experiencia, objetividad y visión fortalecen la toma de decisiones, impulsan la profesionalización y generan mayor valor, transparencia y sostenibilidad para la empresa.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757432484/ebm/79a35dbd-2075-4e0b-b679-6a5e8fd4a906.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-09',
      archivo: 'https://drive.google.com/file/d/1a6aUdhDBGKtNLOdUs9MysrmzYmp30Mma/view'
    },
    {
      titulo: 'Importancia de la responsabilidad social corporativa',
      tipo: 'E-BOOK',
      descripcion: 'Transforma tu organización a través de la Responsabilidad Social Corporativa (RSC). Descubre cómo eleva la productividad y el entorno de tu empresa. Conoce los resultados y sus ventajas tangibles.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757606307/ebm/a06444b8-db7a-49aa-99a3-5a3603d1b804.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-11',
      archivo: 'https://drive.google.com/file/d/1D9A4I0a71o9EWZBNaOdegVpYabuOQMgx/view'
    },
    {
      titulo: 'Familia empresaria: Caminando juntos hacia el éxito empresarial',
      tipo: 'E-BOOK',
      descripcion: 'Aprende a diseñar una estructura de gobierno familiar y conoce el uso del Protocolo Familiar, la herramienta definitiva para gestionar la duplicidad de roles, evitar conflictos y planificar una sucesión generacional exitosa.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757606381/ebm/ce1ddb92-c8b9-4b6a-8b9f-12820071a831.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-11',
      archivo: 'https://drive.google.com/file/d/16fQ18NQrSCcMC9zVUh0bCtlICBSbaxeY/view'
    },
    {
      titulo: 'Comité directivo: Variables para su éxito',
      tipo: 'E-BOOK',
      descripcion: 'Aprende a analizar las tres dimensiones fundamentales para transformar a tu equipo de alta dirección en un órgano de máximo rendimiento, capaz de mantener el éxito sostenible del negocio independientemente de las condiciones del mercado.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757606454/ebm/09218980-669e-4f65-95ca-5abc40e22e8c.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-11',
      archivo: 'https://drive.google.com/file/d/1p2EoM3aJ4bzXJw2hsO3nP54kT1IM4bul/view'
    },
    {
      titulo: 'BR Family Office',
      tipo: 'E-BOOK',
      descripcion: 'Descubre una metodología basada en tres pilares clave: institucionalización, sucesión y trascendencia. Conoce también el alcance del Multi-Family Office y cómo gestiona el patrimonio a través de soluciones financieras, fiscales, legales y de gobernanza.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757606511/ebm/dbb039a3-01eb-4322-81f1-e50de428556f.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-11',
      archivo: 'https://drive.google.com/file/d/12bObMtqIR71VANs_wCZJ54TIQ7N4uU_8/view'
    },
    {
      titulo: 'Compensación de consejeros',
      tipo: 'INFOGRAFÍA',
      descripcion: 'Aprende cómo retribuir adecuadamente al talento estratégico de tu negocio. A través de este documento conocerás las formas de pago más comunes del mercado y sus tabuladores promedio.',
      imagen: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1757606599/ebm/4924d6b0-c196-4835-b3b2-9d4c66af76ea.png',
      categoria: 'EMPRESA FAMILIAR',
      fecha: '2025-09-11',
      archivo: 'https://drive.google.com/file/d/10MyDZG0FQY8G8UF_GG4UT6lfdZCZnAUB/view'
    },
  ];

  const [recursosDestacados, setRecursosDestacados] = useState([]);

  // Funciones utilitarias para el tracking de descargas
  const incrementarDescargas = (titulo) => {
    const datos = JSON.parse(sessionStorage.getItem('descargas')) || {};
    datos[titulo] = (datos[titulo] || 0) + 1;
    sessionStorage.setItem('descargas', JSON.stringify(datos));
  };

  const obtenerRecursosMasDescargados = (recursos, top = 3) => {
    const datos = JSON.parse(sessionStorage.getItem('descargas')) || {};
    const recursosConContador = recursos.map(r => ({
      ...r,
      descargas: datos[r.titulo] || 0
    }));
    return recursosConContador.sort((a, b) => b.descargas - a.descargas).slice(0, top);
  };

  useEffect(() => {
    const destacados = obtenerRecursosMasDescargados(recursosDisponibles, 3);
    setRecursosDestacados(destacados);
  }, []);

  const handleSuscribirse = (formData) => {
    console.log('Datos del formulario:', formData);
    setEstaSuscrito(true);
    sessionStorage.setItem('estaSuscrito', 'true');
  };

  return (

     <>
        <Helmet>
          <title>Hub Formativo | EBM Consultores</title>
          <meta
            name="description"
            content="Consultoría especializada en Empresa Familiar, Gobierno Corporativo y Legado Patrimonial. Descubre cómo acompañamos tu evolución."
          />
        </Helmet>

    <Container
      sx={{
        margin: '0',
        padding: '0 !important',
        maxWidth: '100vw !important',
        overflowX: 'hidden',
        backgroundColor: '#1F1F1F',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      <Banner
        backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193914/ebm/fondoHub_bfrfhd.png"
        title={
          <Box
            sx={{
              color: 'white',
              padding: '0px 20px',
              borderRadius: '5px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              fontSize: { xs: '24px', sm: '30px', md: '50px' },
              maxWidth: { xs: '90%', sm: '700px', md: '937px' },
              margin: '0 auto',
              textShadow: '0px 2px 10px rgba(0,0,0,0.5)',
            }}
          >
            <Box
              component="span"
              sx={{
                position: 'relative',
                px: '2vw',
                py: '0.3em',
                width: { xs: '90%', sm: '502px' },
                height: '65px',
                margin: '0 auto',
                borderRadius: '50rem',
                background: 'linear-gradient(rgba(10, 98, 116, 0), rgba(10, 98, 116, 0.5))',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
                fontWeight: 500,
                fontSize: { xs: '26px', sm: '36px', md: '48px' },
                zIndex: 1,
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  padding: '1px',
                  borderRadius: '50rem',
                  background: 'linear-gradient(90deg, #0ff, rgba(10, 98, 116, 0))',
                  WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                  WebkitMaskComposite: 'xor',
                  maskComposite: 'exclude',
                  zIndex: -1,
                },
              }}
            >
              <Box component="span" sx={{ fontWeight: 700, pr: 1 }}>
                HUB
              </Box>
              <Box component="span">FORMATIVO</Box>
            </Box>

            <Typography
              sx={{
                mt: 2,
                fontSize: { xs: '14px', sm: '16px' },
                fontWeight: 500,
                color: 'white',
                fontFamily: 'Poppins, sans-serif',
                textShadow: '0px 1px 4px rgba(0, 0, 0, 0.5)',
              }}
            >
              Accede a conocimientos, herramientas y recursos que impulsan tu éxito y el de tu legado.
            </Typography>
          </Box>
        }
        subtitlePosition="top"
        variant="centered"
      />

      {/* Sección con blur y texto de bienvenida animado */}
      <Box
        ref={blurRef}
        sx={{
          position: 'absolute',
          top: { xs: '100%', sm: '55%', md: '82%' }, // Ajusta según lo alto que lo quieras
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: '1105px',
          borderRadius: '20px',
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 0 10px rgba(0,0,0,0.5)',
          px: { xs: 2, sm: 4, md: 6 },
          py: { xs: 3, sm: 4, md: 5 },
          zIndex: 2,
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.8s ease, transform 0.8s ease',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '14px', sm: '16px', md: '20px' },
            lineHeight: 1.6,
            color: '#D4A76A',
            fontWeight: 400,
          }}
        >
          Tu punto de acceso a{' '}
          <Box component="span" sx={{ fontWeight: 700 }}>recursos exclusivos</Box>{' '}
          para la gestión efectiva de tu familia, empresa y patrimonio. En este espacio{' '}
          <strong>encontrarás herramientas útiles, guías prácticas y materiales educativos</strong>{' '}
          <Box component="span" sx={{ fontWeight: 700 }}>
            que te ayudarán a tomar decisiones estratégicas e informadas.
          </Box>
        </Typography>
      </Box>

      {/* Imagen de fondo con título y carrusel */}
      {/* <Box
        sx={{
          width: '100vw',
          backgroundImage: {
            xs: 'url("/bg-categorias-mobile.png")',
            md: 'url("/5395.png")',
          },
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          mt: { xs: '-130px', sm: '-160px', md: '-180px' },
          px: { xs: 2, md: 6 },
          pt: { xs: 8, sm: 10, md: 12 },
          pb: { xs: 10, sm: 12, md: 14 },
        }}
      >
        <Box
          sx={{
            maxWidth: '1213px',
            mx: 'auto',
            textAlign: 'center',
            zIndex: 1,
            position: 'relative',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '20px', sm: '24px', md: '30px' },
              color: '#DADADA',
              mb: 1,
              mt: { xs: '100px', md: '100px' },
            }}
          >
          </Typography>
        </Box>

        <FormacionCarousel
          estaSuscrito={estaSuscrito}
          onSuscribirse={() => setModalAbierto(true)}
        />
      </Box> */}


      {/* HUB FORMATIVO - Secciones de suscripción ocultas (¿Cómo acceder? + Formulario)
      <SectionHowtoAccess />
      <SeccionSuscripcion />
      */}

      {/* Sección de recursos destacados */}
      <Box sx={{ py: { xs: 6, sm: 8, md: 10 }, px: { xs: 2, sm: 4, md: 8 }, textAlign: 'center', background: '#F5F5F5' }}>
        <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '20px', sm: '24px', md: '32px' } }}>
          Recursos <Box component="span" sx={{ color: '#0A6274' }}>destacados</Box>
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '30px',
            mt: { xs: 2, sm: 3 }
          }}
        >
          {recursosDestacados.map((recurso, index) => (
            <Box key={index} sx={{ width: '296px' }}>
              <RecursoDestacado
                recurso={recurso}
                estaSuscrito={estaSuscrito}
                onDownload={() => {
                  if (estaSuscrito) {
                    incrementarDescargas(recurso.titulo);
                    window.open(recurso.archivo, '_blank');
                    const actualizados = obtenerRecursosMasDescargados(recursosDisponibles, 3);
                    setRecursosDestacados(actualizados);
                  }
                  // HUB FORMATIVO - Ya no redirige al formulario de suscripción
                  // else {
                  //   document.getElementById('formulario-suscripcion')?.scrollIntoView({ behavior: 'smooth' });
                  // }
                }}
              />
            </Box>
          ))}
        </Box>
      </Box>

      <ArticulosConPaginacion
        articulos={articulos}
        estaSuscrito={estaSuscrito}
        onSuscribirse={handleSuscribirse}
      />

      {/* Carrusel con artículos de WordPress */}
      <Box sx={{
        backgroundColor: 'white',
        pb: 10,
        pt: 8,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        borderBottom: '1px solid #E0E0E0'
      }}>
        <Typography sx={{
          py: 4,
          color: '#0A6274',
          fontSize: { xs: '1.6rem', md: '2rem' },
          fontWeight: 600,
          textAlign: 'center'
        }}>
          Explora nuestros <b>últimos insights</b>
        </Typography>

        {isLoadingArticles ? (
          <Box sx={{ height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress color="primary" />
          </Box>
        ) : wordpressArticles.length > 0 ? (
          <CarouselArticulos wpData={wordpressArticles} />
        ) : (
          <Typography>No hay artículos disponibles</Typography>
        )}
      </Box>
    </Container>
    </>
  );
}